import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { faGift } from '@fortawesome/pro-solid-svg-icons'
import _ from 'lodash'
import { ItList } from 'types/graphql'

import { routes } from '@redwoodjs/router'

import Placeholder from 'src/assets/image/PlaceholderGenericSVG'
import Icon from 'src/components/widgets/Icon/Icon'
import UnlistedTag from 'src/components/widgets/ItListCard/UnlistedTag/UnlistedTag'
import ItListImage from 'src/components/widgets/ItListImage/ItListImage'
import { ItListAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import { asPrice, getAbsoluteUrl, slugify } from 'src/lib/utils'
import { BrandColor } from 'src/types'

import ItListTopActions from './ItListTopActions/ItListTopActions'

type ItListDetailsHeaderProps = {
  itList: ItList
  isPreview: boolean
  locked: boolean
  brandColor: BrandColor
  trackingData: ItListAnalyticsProps
  buy(): void
}

const ItListDetailsHeader = ({
  itList,
  isPreview,
  locked,
  brandColor,
  trackingData,
  buy,
}: ItListDetailsHeaderProps) => {
  return (
    <Flex
      position="relative"
      flexDirection="column"
      alignItems="center"
      h="416px"
      mb={6}
      id="it-list-item-cover"
    >
      {itList?.coverUrl ? (
        <ItListImage
          htmlWidth={744}
          borderRadius={{ base: 0, lg: isPreview ? 0 : 16 }}
          objectFit="cover"
          h="100%"
          w="100%"
          maxW="none"
          data-testid="itListDetails-coverImage"
          src={itList.coverUrl}
          alt={`Cover image for ${itList.name || `itList #${itList.id}`}`}
        />
      ) : (
        <Placeholder style={{ height: '100%', width: '100%' }} />
      )}

      <Flex left={4} bottom={4} position="absolute" gap={2}>
        {itList.relationship === 'owner' && (
          <Text
            className="body-regular-emphasis"
            paddingX="10px"
            paddingY="6px"
            borderRadius="full"
            backgroundColor="white"
            color="onyx"
            data-testid="itListDetails-priceTag"
          >
            {+itList?.price === 0 ? 'Free' : asPrice(itList.price)}
          </Text>
        )}
        {itList?.unlisted && (
          <UnlistedTag creatorFirstName={itList?.creator?.firstName} />
        )}
        {itList.relationship !== 'owner' && !locked && !!itList.price && (
          <Button
            className="body-regular-emphasis"
            paddingX="16px"
            paddingY="6px"
            borderRadius="full"
            backgroundColor="white"
            color="onyx"
            onClick={() => {
              buy()
            }}
            alignItems="center"
            fontWeight={700}
          >
            <Icon icon={faGift} color={brandColor} mr={2} fontSize={13} />
            <Box>Gift this ItList</Box>
          </Button>
        )}
      </Flex>

      {!isPreview && (
        <ItListTopActions
          position="absolute"
          bottom={4}
          right={4}
          itListId={itList.id}
          liked={itList.liked}
          url={getAbsoluteUrl(
            routes.itList({
              id: itList.id,
              title: slugify(itList.name),
              ...(itList.affiliateId ? { a: itList.affiliateId } : null),
            })
          )}
          trackingData={trackingData}
        />
      )}
    </Flex>
  )
}

export default ItListDetailsHeader
